var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.categories,"item-value":"name","item-text":"name","label":_vm.label,"clearable":""},model:{value:(_vm.localCategory),callback:function ($$v) {_vm.localCategory=$$v},expression:"localCategory"}})}
var staticRenderFns = []

export { render, staticRenderFns }